module.exports = __webpack_public_path__ + "static/media/disabledOffenseIcon.8c3c8381.svg";